import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-12" data-testid="refund-policy-page">
        <h1 className="text-3xl md:text-4xl font-heading font-semibold mb-2">Refund & Return Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: May 2, 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">1. Our Commitment</h2>
            <p>Christ Kingdom Global Marketplace values honest commerce. We believe every buyer deserves the product they paid for — as described, in good condition, delivered on time.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">2. When You Can Request a Refund</h2>
            <p>You are eligible for a refund if, within <strong>14 days</strong> of receiving your order:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>The item arrives damaged or defective</li>
              <li>The item is significantly different from its description</li>
              <li>The item never arrives despite vendor confirmation</li>
              <li>The vendor fails to ship within 10 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">3. Non-Refundable Items</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Digital downloads or services once rendered</li>
              <li>Custom-made or personalized items (unless defective)</li>
              <li>Perishable goods (food, live plants)</li>
              <li>Opened cosmetics, skincare, or hygiene items (for health reasons)</li>
              <li>Real estate deposits once contracts are signed</li>
              <li>Oil & Gas commodity orders after quote acceptance</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">4. How to Request a Refund</h2>
            <ol className="list-decimal pl-6 space-y-1">
              <li>Go to your <strong>Dashboard → Orders</strong></li>
              <li>Find the order and click <strong>Request Refund</strong></li>
              <li>Provide a brief reason and photos if applicable</li>
              <li>The vendor has 3 business days to respond</li>
              <li>If unresolved, we'll mediate within 5 additional business days</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">5. Refund Timing</h2>
            <p>Approved refunds are processed via Stripe back to your original payment method. The money typically appears in your account within <strong>5-10 business days</strong>, depending on your bank.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">6. Returns</h2>
            <p>If a return is required, the buyer is responsible for return shipping unless the item was defective or not as described. Use tracked shipping to avoid disputes.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">7. Partial Refunds</h2>
            <p>In some cases (minor damage, missing accessories), a partial refund may be offered instead of a full refund. This is agreed between buyer and vendor through our mediation.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">8. Marketplace Commission on Refunds</h2>
            <p>When a full refund is issued, the 10% platform commission is also refunded back to the vendor's account — no vendor loses money due to a genuine refund.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">9. Fraud & Abuse</h2>
            <p>Repeated or fraudulent refund claims may result in account suspension. We reserve the right to deny refunds in cases of clear abuse.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold mb-2">10. Contact</h2>
            <p>For refund questions or escalations, email <a href="mailto:support@christkingdomglobalmarketplace.com" className="text-primary underline">support@christkingdomglobalmarketplace.com</a>. Include your Order ID for faster resolution.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
